import React from "react";
import About from "./sub-sections/About";
import Staff from "./sub-sections/Staff";
import Class from "./sub-sections/Class";
import Location from "./sub-sections/Location"
import Gallery from "./sub-sections/Gallery"
import Last from "./sub-sections/Last";

const Sections = () => {
    return(
        <article id="I_title" className="I_title">
            <About/>
            <Staff/>    
            <Gallery/>
            <Class/>
            <Location/>
            <Last/>
        </article>
    );
};

export default Sections;